import React from "react";

export default function MainLoader() {
  return (
    <div className="preloader">
      <div className="loader"></div>
    </div>
  );
}
